<template>
    <footer ref="footer" class="product-footer-mobile" :class="{ 'product-footer-mobile--landscape': isLandscape }">
        <div class="product-footer-mobile__bottomcenter" v-if="checkoutAvailableFrom">
            <p class="checkout-available-from">
                {{ $t('UpsellingFooter.checkoutAvailableFrom', { date: checkoutAvailableFrom }) }}
            </p>
        </div>
        <div class="product-footer-mobile__bottom"  v-else>
            <div v-if="$slots.default" class="product-footer-mobile__bottom-left">
                <slot></slot>
            </div>

            <button class="product-footer-mobile__button btn btn-primary mx-auto" @click.prevent="onClick">
                {{ buttonText }}
            </button>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'ProductFooterMobile',
    props: {
        buttonText: {
            type: String,
            default() {
                return this.$t('ProductDetails.productSelect.secureNow');
            }
        },
        checkoutAvailableFrom: {
            type: String
        }
    },
    data() {
        return {
            disableTransparentOffset: 150,
            landscapeOrientationCheck: null,
            isLandscape: null, //server side is not aware
            cmpRealignIntervalId: null
        };
    },
    methods: {
        onScroll() {
            if (window.pageYOffset >= this.disableTransparentOffset) {
                 this.$refs.footer && this.$refs.footer.classList.add('product-footer-mobile--scrolled');
            } else {
                 this.$refs.footer && this.$refs.footer.classList.remove('product-footer-mobile--scrolled');
            }
        },
        processOrientation(e) {
            this.isLandscape = e.matches;
            if (this.isLandscape) {
                window.addEventListener('scroll', this.onScroll);
                //this.disableTransparentOffset = screen.height;
                setTimeout(this.onScroll, 0); //prevents footer from being invisible after orientation change without a scroll action
            } else {
                window.removeEventListener('scroll', this.onScroll);
            }
        },
        onClick() {
            if (this.isInsideIframe() && this.$nuxt.iframeLayout) {
                this.$nuxt.iframeLayout.postScrollToParent();
            }
            this.$emit('click');
        },
        isInsideIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        realignCMPIcon() {
            if (process.client) {
                const cmpIcon = document.querySelector('#cmpboxrecall');
                if (cmpIcon) {
                    clearInterval(this.cmpRealignIntervalId);
                    cmpIcon.classList.add('product-footer-mobile__cmp-icon');

                    this.$on('hook:beforeDestroy', () => {
                        if (cmpIcon && cmpIcon.classList) {
                            cmpIcon && cmpIcon.classList.remove('product-footer-mobile__cmp-icon');
                        }
                    });
                } else if (!this.cmpRealignIntervalId) {
                    //subsequent attempts, handy when page loaded through ssr

                    (function (numberOfAttempts) {
                        this.cmpRealignIntervalId = setInterval(() => {
                            if (numberOfAttempts > 2) {
                                clearInterval(this.cmpRealignIntervalId);
                                return;
                            }

                            numberOfAttempts++;
                            this.realignCMPIcon();
                        }, 1000);
                    }).bind(this)(0);
                }
            }
        },
        increaseHeightForNettoApp() {
            if (this.$refs.footer) {
                this.$refs.footer.style.height = '120px';
            }
        }
    },
    mounted() {
        this.landscapeOrientationCheck = window.matchMedia('(orientation: landscape)');
        this.isLandscape = this.landscapeOrientationCheck.matches;

        this.landscapeOrientationCheck.addListener(this.processOrientation);
        this.processOrientation(this.landscapeOrientationCheck);

        if (
            this.$nuxt.iframeLayout &&
            typeof this.$nuxt.iframeLayout.isInsideIframe === 'function' &&
            this.$nuxt.iframeLayout.isInsideIframe()
        ) {
            if (
                this.$store.state.ident === 'netto-discount' &&
                typeof this.$nuxt.iframeLayout.isWebView === 'function' &&
                this.$nuxt.iframeLayout.isWebView()
            ) {
                this.increaseHeightForNettoApp();
            }
            this.$nuxt.iframeLayout.fixPositionInIframe(this.$el);
        }

        this.realignCMPIcon();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
        this.landscapeOrientationCheck.removeListener(this.processOrientation);
    }
};
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/styles/variables';

.product-footer-mobile {
    $self: &;
    display: flex; //to support gap
    flex-direction: column;
    gap: 10px;
    background-color: var(--white);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -1px 5px 3px rgba(0, 0, 0, 0.1);
    z-index: map.get(variables.$z-indices, 'footer-mobile');
    padding: 10px variables.$grid-padding;

    &__bottom {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        align-items: center;
    }

    &__bottomcenter {
        display: flex;
        justify-content: center;
        gap: 10px;
        align-items: center;
        text-align: center;

        p.checkout-available-from {
            font-weight: bold;
            color: #930202;
        }
    }

    &__bottom-left {
        margin-left: auto;
        margin-right: auto;
        min-width: 100px;
        display: flex;
        align-items: center;
        flex-direction: column;
        flex: 1 0 auto;
    }

    &__button {
        font-size: 18px;
        font-weight: bold;
        width: 100%;
        max-width: 300px;
        min-height: 48px; //mobile usability fix
        white-space: nowrap; // still always test if it fits on mobile (360px)
    }

    &--landscape {
        transition: opacity 0.3s ease-in-out;
        opacity: 0;

        &#{$self}--scrolled {
            opacity: 1;
        }
    }

    @media print {
        position: static;
    }
}
</style>

<style lang="scss">
@use 'sass:map';
@use '@/styles/variables';

.product-footer-mobile {
    &__cmp-icon {
        bottom: 80px !important;
        z-index: map.get(variables.$z-indices, 'footer-mobile') + 1 !important;
    }
}
</style>
